import styled from "styled-components";

export const Wrap = styled.div`
  position: relative;
  max-width: 370px;
  @media (max-width: 767px) {
    margin: 0 auto;
  }
`;
export const Pic = styled.img`
  position: relative;
  max-width: 100%;
  height: auto;
  min-height: 400px;
  max-height: 600px;
  object-fit: cover;
  border-radius: var(--root-br);
  @media (max-width: ${({ theme }) => theme.mobileBp}) {
    min-height: 200px;
  }
`;

export const UploadButtonContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  border-radius: 50%;
  display: flex;
  width: 40px;
  height: 40px;
  background-color: var(--bg-root);
  z-index: 3 !important;
  > button {
    margin: auto;
  }
`;
